export const initBookingAccountTaxes = () => {
  const bookingAccountTaxes = document.getElementById("booking-account-taxes") as HTMLDivElement;

  if (!bookingAccountTaxes) {
    return;
  }

  const countrySelect = document.getElementById("taxAddressCountry") as HTMLSelectElement;
  const taxIdLabel = document.getElementById("tax_id_label");
  const taxIdInput = document.getElementById("tax_id") as HTMLInputElement | null;
  const noTaxIdWrapper = document.getElementById("no_tax_id_wrapper");
  const noTaxIdCheckbox = document.getElementById("no_tax_id") as HTMLInputElement | null;
  const birthPlaceFields = document.getElementById("birth_place_fields");
  const birthCityInput = document.getElementById("birth_city") as HTMLInputElement | null;
  const birthCountrySelect = document.getElementById("birth_country") as HTMLSelectElement | null;

  if (!countrySelect || !taxIdLabel) {
    return;
  }

  // The countries whose tax administration issues no tax ID at all, so a babysitter there may
  // legitimately have none. Everywhere else the checkbox stays hidden and the number is required.
  const countriesWithoutTaxId: string[] = JSON.parse(
    noTaxIdWrapper?.dataset.countriesWithoutTaxId ?? "[]",
  );

  const updateTaxIdField = () => {
    const selectedCountry = countrySelect.value;

    // Hide all label spans
    const allSpans = taxIdLabel.querySelectorAll<HTMLSpanElement>("[data-tax-label-country]");
    Array.from(allSpans).forEach((span) => {
      span.classList.add("d-none");
    });

    // Show the span for the selected country
    const selectedSpan = taxIdLabel.querySelector<HTMLSpanElement>(
      `[data-tax-label-country="${selectedCountry}"]`,
    );
    if (selectedSpan) {
      selectedSpan.classList.remove("d-none");
    }

    // Show the format hint for the selected country, so the length of the example
    // matches what the validator accepts for that country
    if (taxIdInput) {
      const selectedOption = countrySelect.selectedOptions[0];
      taxIdInput.placeholder = selectedOption?.dataset.taxPlaceholder ?? "";
    }
  };

  // Kept out of the input while the box is ticked, so that unticking hands the number straight
  // back instead of making the seller retype it. Memory only — it never leaves the page.
  let setAsideTaxId = "";

  const updateNoTaxIdFields = () => {
    const countryIssuesNoTaxId = countriesWithoutTaxId.includes(countrySelect.value);

    noTaxIdWrapper?.classList.toggle("d-none", !countryIssuesNoTaxId);

    // Moving to a country that does issue one retracts the claim, so the seller cannot carry a
    // hidden "I have none" over from a country where it was allowed.
    if (noTaxIdCheckbox && !countryIssuesNoTaxId) {
      noTaxIdCheckbox.checked = false;
    }

    // The checkbox names the number the way the selected country does, so its label switches
    // with the country just like the input's label does.
    const labelSpans = noTaxIdWrapper?.querySelectorAll<HTMLSpanElement>(
      "[data-no-tax-id-country]",
    );
    Array.from(labelSpans ?? []).forEach((span) => {
      span.classList.toggle("d-none", span.dataset.noTaxIdCountry !== countrySelect.value);
    });

    const hasNoTaxId = countryIssuesNoTaxId && (noTaxIdCheckbox?.checked ?? false);

    birthPlaceFields?.classList.toggle("d-none", !hasNoTaxId);

    // Empty the field while the box is ticked. A greyed-out box still showing a number reads as
    // "this gets sent anyway", which is the opposite of what the seller just declared.
    if (taxIdInput) {
      if (hasNoTaxId) {
        if (taxIdInput.value !== "") {
          setAsideTaxId = taxIdInput.value;
        }

        taxIdInput.value = "";
      } else if (taxIdInput.value === "" && setAsideTaxId !== "") {
        taxIdInput.value = setAsideTaxId;
        setAsideTaxId = "";
      }

      // DAC7 takes the place of birth in place of the missing number, so the two swap requiredness.
      taxIdInput.required = !hasNoTaxId;
      taxIdInput.disabled = hasNoTaxId;
    }

    if (birthCityInput) {
      birthCityInput.required = hasNoTaxId;
    }

    if (birthCountrySelect) {
      birthCountrySelect.required = hasNoTaxId;
    }
  };

  countrySelect.addEventListener("change", () => {
    updateTaxIdField();
    updateNoTaxIdFields();
  });

  noTaxIdCheckbox?.addEventListener("change", updateNoTaxIdFields);

  updateNoTaxIdFields();
};
